module.exports = __webpack_public_path__ + "img/map-location.23f7eb8.svg";